import * as React from 'react';

import { Translate } from 'react-localize-redux';

import styled, { css } from 'styled-components';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import QuestionMarkHelper from '@components/basics/question-mark-helper';

export interface HintProps {
  children?: any;
  className?: string;
  noTitle?: boolean;
  customTitle?: React.ReactNode;
  helperText?: React.ReactNode;
  helperTextId?: string;
  weight?: string;
  noMargin?: boolean;
  align?: 'left' | 'center' | 'right';
  noBorderTop?: boolean;
  noBorderBottom?: boolean;
  noBorderLeft?: boolean;
  noBorderRight?: boolean;
  gray?: boolean;
  lightRedBackground?: boolean;
  customContent?: React.ReactNode;
  error?: boolean;
  isSmall?: boolean;
  customBorderRadius?: string;
  noHelperText?: boolean;
}

export const Hint: React.FC<HintProps> = (props) => (
  <div className={props.className}>
    {props.noTitle ? null : (
      <Wrapper justifyContent="flex-start" alignItems="center" gap={10}>
        <HintTitle type={props.isSmall ? 'small' : undefined}>
          {props.customTitle ? (
            props.customTitle
          ) : (
            <Translate id="HINT.TITLE" />
          )}
        </HintTitle>
        {props.helperTextId && props.helperText && !props.noHelperText && (
          <QuestionMarkHelper id={props.helperTextId || ''}>
            {props.helperText}
          </QuestionMarkHelper>
        )}
      </Wrapper>
    )}
    {!props.customContent && (
      <HintText weight={props.weight} type="small">
        {props.children}
      </HintText>
    )}
    {props.customContent && props.customContent}
  </div>
);

export default styled(Hint)`
  background: ${({ theme }) => theme.colors.hint};
  padding: 30px;
  border-radius: 10px;
  margin-top: 10px;

  ${(props) =>
    props.customBorderRadius
      ? css`
          border-radius: ${props.customBorderRadius};
        `
      : null};

  ${(props) =>
    props.isSmall
      ? css`
          padding: 15px;
        `
      : null};

  ${(props) =>
    props.gray
      ? css`
          background: ${({ theme }) => theme.colors.secondary};
        `
      : null};

  ${(props) =>
    props.lightRedBackground
      ? css`
          background: ${({ theme }) => theme.colors.pink};
        `
      : null};

  ${(props) =>
    props.error
      ? css`
          background: ${({ theme }) => theme.colors.accentLight};
        `
      : null};

  ${(props) =>
    props.noBorderTop
      ? css`
          margin-top: 3px;
          border-top-left-radius: 0px;
          border-top-right-radius: 0px;
        `
      : null};

  ${(props) =>
    props.noBorderBottom
      ? css`
          border-bottom-left-radius: 0px;
          border-bottom-right-radius: 0px;
        `
      : null};

  ${(props) =>
    props.noBorderLeft
      ? css`
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
        `
      : null};

  ${(props) =>
    props.noBorderRight
      ? css`
          border-bottom-right-radius: 0px;
          border-top-right-radius: 0px;
        `
      : null};

  ${(props) =>
    props.noTitle && !props.align
      ? css`
          text-align: center;
        `
      : null}

  ${(props) =>
    props.align
      ? css`
          text-align: ${props.align};
        `
      : null}

  ${(props) =>
    props.noMargin
      ? css`
          margin-top: 0;
        `
      : null}
`;

export const HintTitle = styled(Typography).attrs(() => ({
  weight: '700',
}))`
  color: ${({ theme }) => theme.colors.black};
`;

export const HintText = styled(Typography)`
  color: ${({ theme }) => theme.colors.black};
`;

const Wrapper = styled(Flex)`
  margin-bottom: 5px;
`;
